// extracted by mini-css-extract-plugin
export default {"resultContainer":"styles_resultContainer__qHSj7"};